import _ from 'lodash'
import {linkMapping} from '../components/link/links'

export const getLinkFromMapping = link => {
	return _.isString(link) ? linkMapping[link] : link
}
